// Tour Targets
const CONTENT_HIGHLIGHTS = 'highlights-link';
const LEARNER_CREDIT = 'learner-credit-link';
const PEOPLE_MANAGEMENT = 'people-management-link';
const SETTINGS_SIDEBAR = 'settings-sidebar-link';
const ANALYTICS_SIDEBAR = 'analytics-sidebar';

export const TOUR_TARGETS = {
  CONTENT_HIGHLIGHTS,
  LEARNER_CREDIT,
  PEOPLE_MANAGEMENT,
  SETTINGS_SIDEBAR,
  ANALYTICS_SIDEBAR,
};

export const BROWSE_AND_REQUEST_TOUR_COOKIE_NAME = 'dismissed-browse-and-request-tour';
export const HIGHLIGHTS_COOKIE_NAME = 'dismissed-highlights-tour';
export const LEARNER_CREDIT_COOKIE_NAME = 'dismissed-learner-credit-tour';
export const LEARNER_DETAIL_PAGE_COOKIE_NAME = 'dismissed-learner-detail-page-tour';
export const PORTAL_APPEARANCE_TOUR_COOKIE_NAME = 'dismissed-portal-appearance-tour';
export const ANALYTICS_COOKIE_NAME = 'dismissed-analytics-tour';

export const COOKIE_NAMES = {
  BROWSE_AND_REQUEST_TOUR_COOKIE_NAME,
  HIGHLIGHTS_COOKIE_NAME,
  LEARNER_CREDIT_COOKIE_NAME,
  LEARNER_DETAIL_PAGE_COOKIE_NAME,
  PORTAL_APPEARANCE_TOUR_COOKIE_NAME,
  ANALYTICS_COOKIE_NAME,
};

export const BROWSE_AND_REQUEST_ADVANCE_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.browse-and-request.advanced';
export const BROWSE_AND_REQUEST_DISMISS_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.browse-and-request.dismissed';
export const BROWSE_AND_REQUEST_ON_END_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.browse-and-request.navigated-to-page';

export const HIGHLIGHTS_ADVANCE_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.highlights.advanced';
export const HIGHLIGHTS_DISMISS_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.highlights.dismissed';
export const HIGHLIGHTS_ON_END_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.highlights.navigated-to-page';

export const LEARNER_CREDIT_ADVANCE_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.learner-credit.advanced';
export const LEARNER_CREDIT_DISMISS_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.learner-credit.dismissed';
export const LEARNER_CREDIT_ON_END_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.learner-credit.navigated-to-page';

export const LEARNER_DETAIL_PAGE_DISMISS_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.learner-detail-page.dismissed';

export const PORTAL_APPEARANCE_ADVANCE_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.portal-appearance.advanced';
export const PORTAL_APPEARANCE_DISMISS_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.portal-appearance.dismissed';
export const PORTAL_APPEARANCE_ON_END_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.portal-appearance.navigated-to-page';

export const ANALYTICS_ADVANCE_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.analytics.advanced';
export const ANALYTICS_DISMISS_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.analytics.dismissed';
export const ANALYTICS_ON_END_EVENT_NAME = 'edx.ui.enterprise.admin-portal.tours.analytics.navigated-to-page';

export default {
  TOUR_TARGETS,
};
